import React from "react";

import { PageIntro, SectionCard } from "../../components/goldbot/GoldBotCards";
import {
  buildLivePositionRows,
  getPositionsTableState,
} from "../../components/goldbot/goldBotPositionViewModel";
import { useGoldBotPositions } from "../../hooks/useGoldBotPositions";

const columnCount = 11;

/* Each cell carries a `data-label`. On a desktop it is inert; below 700px
   GoldBot.css turns the row into a card and renders the label beside the
   value, so no column is lost to a sideways scroll on a phone. The labels
   mirror the <th> text above. */

function GoldBotPositions() {
  const { data, error, isLoading } = useGoldBotPositions();
  const rows = data ? buildLivePositionRows(data.positions) : [];
  const tableState = getPositionsTableState({
    data,
    error,
    isLoading,
    rowCount: rows.length,
  });

  return (
    <>
      <PageIntro eyebrow="Current exposure" title="Open Positions" description="Review every active GoldBot trade and its current risk profile." />
      <SectionCard title="Live Positions" eyebrow={tableState.eyebrow}>
        <div className="goldbot-table-wrap">
          <table className="goldbot-table">
            <thead><tr><th>Symbol</th><th>Strategy</th><th>Buy/Sell</th><th>Lot</th><th>Entry</th><th>Current Price</th><th>SL</th><th>TP</th><th>Profit</th><th>Current R</th><th>Duration</th></tr></thead>
            <tbody>
              {tableState.message ? (
                <tr>
                  <td colSpan={columnCount}>{tableState.message}</td>
                </tr>
              ) : (
                rows.map((position) => (
                  <tr key={position.id}>
                    <td className="goldbot-table__symbol" data-label="Symbol">{position.symbol}</td><td data-label="Strategy">{position.strategy}</td>
                    <td data-label="Buy/Sell"><span className={`goldbot-side is-${position.side.toLowerCase()}`}>{position.side}</span></td>
                    <td data-label="Lot">{position.lot}</td><td data-label="Entry">{position.entry}</td><td data-label="Current Price">{position.current}</td><td data-label="SL">{position.sl}</td><td data-label="TP">{position.tp}</td>
                    <td className={position.profitTone} data-label="Profit">{position.profit}</td><td data-label="Current R">{position.r}</td><td data-label="Duration">{position.duration}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </SectionCard>
    </>
  );
}

export default GoldBotPositions;
